import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import InventoryItemSection from '../InventoryItemSection'
import InventorySectionHeader from './InventorySectionHeader'
import InventoryAvailability from '../InventoryAvailability'

import { isAdInventoryTargetingEnabled } from '../../../../../../../forms/GAM/UploadGamAdCreative/UploadGamAdCreativeForm/LineItemForm/formatters/formatInventoryTargeting'
import { useRemainingBudgetValidation } from '../../../../../../../forms/GAM/UploadGamAdCreative/UploadGamAdCreativeForm/LineItemForm/hooks/remainingBudgetHooks'
import {
  getAllocationInfo,
  getIsBudgetAllocationType
} from '../../../../../../../forms/Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/GamOnsiteRightCreateSections/helpers'
import {
  getGamInventoryType,
  inventoryTypes
} from '../../../../../../../forms/GAM/UploadGamAdCreative/UploadGamAdCreativeForm/LineItemForm/helpers'

import { rightSelector } from '../../../../../../../modules/selectors/rights'

import {
  AD_INVENTORY,
  IS_SUB_ALLOCATION
} from '../../../../../../../forms/Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/fields'
import { ALLOCATION } from '../../../../../../../forms/Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/GamOnsiteRightCreateSections/InventoryAccessAndAllocationSection/SubAllocationTables/fields'

import useStyles from './styles'

const AllInventorySection = () => {
  const classes = useStyles()

  const right = useSelector(rightSelector)
  const inventory = right[AD_INVENTORY]
  const { isPercentageAllocation } = getAllocationInfo(right)
  const adInventoryTargetingEnabled = isAdInventoryTargetingEnabled(right)
  const isSubAllocation = right[IS_SUB_ALLOCATION]
  const { remainingBudget } = useRemainingBudgetValidation()
  const isBudgetAllocationType = getIsBudgetAllocationType(right)
  const inventoryType = getGamInventoryType(right[AD_INVENTORY])

  const allocation = useMemo(() => {
    if (isBudgetAllocationType) {
      return right.budget
    } else {
      return right[ALLOCATION]
    }
  }, [isBudgetAllocationType, right])

  const showRemaining = useMemo(() => {
    if (isPercentageAllocation) {
      // if targeting disabled we show remaining days on the main "All inventory" section
      return !adInventoryTargetingEnabled
    } else {
      return !isSubAllocation
    }
  }, [isPercentageAllocation, adInventoryTargetingEnabled, isSubAllocation])

  return (
    <InventoryItemSection
      name={inventoryType === inventoryTypes.placements ? 'All placements' : 'All ad units'}
      headerChildren={
        <InventorySectionHeader
          // all inventory from the right
          inventory={right[AD_INVENTORY]}
          // Don't show allocation on the main "All inventory" section for sub-allocations
          showAllocation={!isSubAllocation}
          showRemaining={showRemaining}
          allocation={allocation}
          remainingBudget={remainingBudget}
        />
      }
      titleClassName={classes.title}
      initialIsOpened={true}
    >
      <InventoryAvailability
        inventory={inventory}
        // DO NOT show All placements availability heatmaps for single allocation sponsorship rights with targeting enabled
        showInventoryTimelines={isPercentageAllocation && !adInventoryTargetingEnabled}
      />
    </InventoryItemSection>
  )
}

AllInventorySection.propTypes = {
  children: PropTypes.node
}

export default AllInventorySection
